/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AttemptStartDto } from '../models';
// @ts-ignore
import type { ConflictProblemDto } from '../models';
// @ts-ignore
import type { ExamCardDto } from '../models';
// @ts-ignore
import type { ExamGradeNewDto } from '../models';
// @ts-ignore
import type { ExamRefusalDto } from '../models';
// @ts-ignore
import type { ProblemDetailDto } from '../models';
// @ts-ignore
import type { TestRefusalDto } from '../models';
/**
 * ExamsApi - axios parameter creator
 * @export
 */
export const ExamsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Only with every question marked, and commented where the question requires a comment. The score is the points earned of the sum of the maxima, and a pass compares the points with the threshold of the test. A practical mark counts in proportion to the question\'s maximum — 3 of 4 on a question worth 8 earns 6; a pass earns the maximum, a fail none. An exam already finished comes back as it is.
         * @summary Finish the exam
         * @param {string} attemptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishExam: async (attemptId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('finishExam', 'attemptId', attemptId)
            const localVarPath = `/api/v1/exams/{attemptId}/finish`
                .replace(`{${"attemptId"}}`, encodeURIComponent(String(attemptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Every question in the order of the parts, as drawn — the version with its topics, scale, key and whether a comment is required, in the same shape as a sample draw — and the grade so far with what it earns. Once finished, the score.
         * @summary The examiner\'s card
         * @param {string} attemptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExam: async (attemptId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('getExam', 'attemptId', attemptId)
            const localVarPath = `/api/v1/exams/{attemptId}`
                .replace(`{${"attemptId"}}`, encodeURIComponent(String(attemptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Saved at once, over the grade before, with the examiner and the time. By the type of the question, and its fields only: a practical question takes topics — exactly as many as it names, by their place on its list from 1 — and a whole-number score on its 0..N scale; a pass or fail question takes passed; an open question, asked out loud, takes points from 0 to its maximum with one decimal place at most. A comment goes with any of them; it is never shown to the person examined.
         * @summary Mark a question, or mark it again
         * @param {string} attemptId 
         * @param {number} index The place of the question in the exam, counted from 1.
         * @param {ExamGradeNewDto} examGradeNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gradeExamQuestion: async (attemptId: string, index: number, examGradeNewDto: ExamGradeNewDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('gradeExamQuestion', 'attemptId', attemptId)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('gradeExamQuestion', 'index', index)
            // verify required parameter 'examGradeNewDto' is not null or undefined
            assertParamExists('gradeExamQuestion', 'examGradeNewDto', examGradeNewDto)
            const localVarPath = `/api/v1/exams/{attemptId}/grades/{index}`
                .replace(`{${"attemptId"}}`, encodeURIComponent(String(attemptId)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(examGradeNewDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For a test whose purpose is the practical exam. The examiner runs it from the panel with a session and marks it question by question; the person examined has no screen and no key. It is an attempt like any other: the same limit, grants, lock, lock after a pass and invalidation, and it shows among the attempts. From every category always the same question, as the test is set up; no time limit.
         * @summary Start a practical exam an examiner runs, for a named person
         * @param {string} testId 
         * @param {AttemptStartDto} attemptStartDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startExam: async (testId: string, attemptStartDto: AttemptStartDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('startExam', 'testId', testId)
            // verify required parameter 'attemptStartDto' is not null or undefined
            assertParamExists('startExam', 'attemptStartDto', attemptStartDto)
            const localVarPath = `/api/v1/tests/{testId}/exams`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attemptStartDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExamsApi - functional programming interface
 * @export
 */
export const ExamsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExamsApiAxiosParamCreator(configuration)
    return {
        /**
         * Only with every question marked, and commented where the question requires a comment. The score is the points earned of the sum of the maxima, and a pass compares the points with the threshold of the test. A practical mark counts in proportion to the question\'s maximum — 3 of 4 on a question worth 8 earns 6; a pass earns the maximum, a fail none. An exam already finished comes back as it is.
         * @summary Finish the exam
         * @param {string} attemptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finishExam(attemptId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamCardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finishExam(attemptId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamsApi.finishExam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Every question in the order of the parts, as drawn — the version with its topics, scale, key and whether a comment is required, in the same shape as a sample draw — and the grade so far with what it earns. Once finished, the score.
         * @summary The examiner\'s card
         * @param {string} attemptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExam(attemptId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamCardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExam(attemptId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamsApi.getExam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Saved at once, over the grade before, with the examiner and the time. By the type of the question, and its fields only: a practical question takes topics — exactly as many as it names, by their place on its list from 1 — and a whole-number score on its 0..N scale; a pass or fail question takes passed; an open question, asked out loud, takes points from 0 to its maximum with one decimal place at most. A comment goes with any of them; it is never shown to the person examined.
         * @summary Mark a question, or mark it again
         * @param {string} attemptId 
         * @param {number} index The place of the question in the exam, counted from 1.
         * @param {ExamGradeNewDto} examGradeNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gradeExamQuestion(attemptId: string, index: number, examGradeNewDto: ExamGradeNewDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gradeExamQuestion(attemptId, index, examGradeNewDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamsApi.gradeExamQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For a test whose purpose is the practical exam. The examiner runs it from the panel with a session and marks it question by question; the person examined has no screen and no key. It is an attempt like any other: the same limit, grants, lock, lock after a pass and invalidation, and it shows among the attempts. From every category always the same question, as the test is set up; no time limit.
         * @summary Start a practical exam an examiner runs, for a named person
         * @param {string} testId 
         * @param {AttemptStartDto} attemptStartDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startExam(testId: string, attemptStartDto: AttemptStartDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamCardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startExam(testId, attemptStartDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamsApi.startExam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExamsApi - factory interface
 * @export
 */
export const ExamsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExamsApiFp(configuration)
    return {
        /**
         * Only with every question marked, and commented where the question requires a comment. The score is the points earned of the sum of the maxima, and a pass compares the points with the threshold of the test. A practical mark counts in proportion to the question\'s maximum — 3 of 4 on a question worth 8 earns 6; a pass earns the maximum, a fail none. An exam already finished comes back as it is.
         * @summary Finish the exam
         * @param {string} attemptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishExam(attemptId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExamCardDto> {
            return localVarFp.finishExam(attemptId, options).then((request) => request(axios, basePath));
        },
        /**
         * Every question in the order of the parts, as drawn — the version with its topics, scale, key and whether a comment is required, in the same shape as a sample draw — and the grade so far with what it earns. Once finished, the score.
         * @summary The examiner\'s card
         * @param {string} attemptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExam(attemptId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExamCardDto> {
            return localVarFp.getExam(attemptId, options).then((request) => request(axios, basePath));
        },
        /**
         * Saved at once, over the grade before, with the examiner and the time. By the type of the question, and its fields only: a practical question takes topics — exactly as many as it names, by their place on its list from 1 — and a whole-number score on its 0..N scale; a pass or fail question takes passed; an open question, asked out loud, takes points from 0 to its maximum with one decimal place at most. A comment goes with any of them; it is never shown to the person examined.
         * @summary Mark a question, or mark it again
         * @param {string} attemptId 
         * @param {number} index The place of the question in the exam, counted from 1.
         * @param {ExamGradeNewDto} examGradeNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gradeExamQuestion(attemptId: string, index: number, examGradeNewDto: ExamGradeNewDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.gradeExamQuestion(attemptId, index, examGradeNewDto, options).then((request) => request(axios, basePath));
        },
        /**
         * For a test whose purpose is the practical exam. The examiner runs it from the panel with a session and marks it question by question; the person examined has no screen and no key. It is an attempt like any other: the same limit, grants, lock, lock after a pass and invalidation, and it shows among the attempts. From every category always the same question, as the test is set up; no time limit.
         * @summary Start a practical exam an examiner runs, for a named person
         * @param {string} testId 
         * @param {AttemptStartDto} attemptStartDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startExam(testId: string, attemptStartDto: AttemptStartDto, options?: RawAxiosRequestConfig): AxiosPromise<ExamCardDto> {
            return localVarFp.startExam(testId, attemptStartDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExamsApi - interface
 * @export
 * @interface ExamsApi
 */
export interface ExamsApiInterface {
    /**
     * Only with every question marked, and commented where the question requires a comment. The score is the points earned of the sum of the maxima, and a pass compares the points with the threshold of the test. A practical mark counts in proportion to the question\'s maximum — 3 of 4 on a question worth 8 earns 6; a pass earns the maximum, a fail none. An exam already finished comes back as it is.
     * @summary Finish the exam
     * @param {string} attemptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamsApiInterface
     */
    finishExam(attemptId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExamCardDto>;

    /**
     * Every question in the order of the parts, as drawn — the version with its topics, scale, key and whether a comment is required, in the same shape as a sample draw — and the grade so far with what it earns. Once finished, the score.
     * @summary The examiner\'s card
     * @param {string} attemptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamsApiInterface
     */
    getExam(attemptId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExamCardDto>;

    /**
     * Saved at once, over the grade before, with the examiner and the time. By the type of the question, and its fields only: a practical question takes topics — exactly as many as it names, by their place on its list from 1 — and a whole-number score on its 0..N scale; a pass or fail question takes passed; an open question, asked out loud, takes points from 0 to its maximum with one decimal place at most. A comment goes with any of them; it is never shown to the person examined.
     * @summary Mark a question, or mark it again
     * @param {string} attemptId 
     * @param {number} index The place of the question in the exam, counted from 1.
     * @param {ExamGradeNewDto} examGradeNewDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamsApiInterface
     */
    gradeExamQuestion(attemptId: string, index: number, examGradeNewDto: ExamGradeNewDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * For a test whose purpose is the practical exam. The examiner runs it from the panel with a session and marks it question by question; the person examined has no screen and no key. It is an attempt like any other: the same limit, grants, lock, lock after a pass and invalidation, and it shows among the attempts. From every category always the same question, as the test is set up; no time limit.
     * @summary Start a practical exam an examiner runs, for a named person
     * @param {string} testId 
     * @param {AttemptStartDto} attemptStartDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamsApiInterface
     */
    startExam(testId: string, attemptStartDto: AttemptStartDto, options?: RawAxiosRequestConfig): AxiosPromise<ExamCardDto>;

}

/**
 * ExamsApi - object-oriented interface
 * @export
 * @class ExamsApi
 * @extends {BaseAPI}
 */
export class ExamsApi extends BaseAPI implements ExamsApiInterface {
    /**
     * Only with every question marked, and commented where the question requires a comment. The score is the points earned of the sum of the maxima, and a pass compares the points with the threshold of the test. A practical mark counts in proportion to the question\'s maximum — 3 of 4 on a question worth 8 earns 6; a pass earns the maximum, a fail none. An exam already finished comes back as it is.
     * @summary Finish the exam
     * @param {string} attemptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamsApi
     */
    public finishExam(attemptId: string, options?: RawAxiosRequestConfig) {
        return ExamsApiFp(this.configuration).finishExam(attemptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Every question in the order of the parts, as drawn — the version with its topics, scale, key and whether a comment is required, in the same shape as a sample draw — and the grade so far with what it earns. Once finished, the score.
     * @summary The examiner\'s card
     * @param {string} attemptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamsApi
     */
    public getExam(attemptId: string, options?: RawAxiosRequestConfig) {
        return ExamsApiFp(this.configuration).getExam(attemptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Saved at once, over the grade before, with the examiner and the time. By the type of the question, and its fields only: a practical question takes topics — exactly as many as it names, by their place on its list from 1 — and a whole-number score on its 0..N scale; a pass or fail question takes passed; an open question, asked out loud, takes points from 0 to its maximum with one decimal place at most. A comment goes with any of them; it is never shown to the person examined.
     * @summary Mark a question, or mark it again
     * @param {string} attemptId 
     * @param {number} index The place of the question in the exam, counted from 1.
     * @param {ExamGradeNewDto} examGradeNewDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamsApi
     */
    public gradeExamQuestion(attemptId: string, index: number, examGradeNewDto: ExamGradeNewDto, options?: RawAxiosRequestConfig) {
        return ExamsApiFp(this.configuration).gradeExamQuestion(attemptId, index, examGradeNewDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For a test whose purpose is the practical exam. The examiner runs it from the panel with a session and marks it question by question; the person examined has no screen and no key. It is an attempt like any other: the same limit, grants, lock, lock after a pass and invalidation, and it shows among the attempts. From every category always the same question, as the test is set up; no time limit.
     * @summary Start a practical exam an examiner runs, for a named person
     * @param {string} testId 
     * @param {AttemptStartDto} attemptStartDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamsApi
     */
    public startExam(testId: string, attemptStartDto: AttemptStartDto, options?: RawAxiosRequestConfig) {
        return ExamsApiFp(this.configuration).startExam(testId, attemptStartDto, options).then((request) => request(this.axios, this.basePath));
    }
}

